export const CoresVeiculo: { value: string; label: string }[] = [
  {
    value: "amarelo",
    label: "Amarelo",
  },
  {
    value: "azul",
    label: "Azul",
  },
  {
    value: "branco",
    label: "Branco",
  },
  {
    value: "laranja",
    label: "Laranja",
  },
  {
    value: "marrom",
    label: "Marrom",
  },
  {
    value: "prata",
    label: "Prata",
  },
  {
    value: "preto",
    label: "Preto",
  },
  {
    value: "rosa",
    label: "Rosa",
  },
  {
    value: "verde",
    label: "Verde",
  },
  { value: "vermelho", label: "Vermelho" },
  {
    value: "vinho",
    label: "Vinho",
  },
];
